import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {StationComponent} from '../station/station.component';
import {VideoComponent} from "../video/video.component";

const routes: Routes = [
  {path: '', redirectTo: '/stacja', pathMatch: 'full'},
  {path: 'stacja', component: StationComponent},
  {path: 'stacja/:label', component: StationComponent},
  {path: 'video', component: VideoComponent},
  {path: 'video/:label', component: VideoComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/routing/app-routing.module.ts